import { createTelemetryAPI } from '~/utils/telemetry'

export const orgsTelemetry = createTelemetryAPI(({ track }) => ({
  clickCreateOrg() {
    return track('Orgs: Click Create Organization Button')
  },
  confirmCreateOrg(id: string, name: string) {
    return track('Orgs: Confirm Create Organization', { id, name })
  },
  searchOrg(name: string) {
    return track('Orgs: Search Org', { name })
  },
  clickPagination({ page, pageSize }: { page: number; pageSize: number }) {
    return track('Orgs: Click Pagination', { page, pageSize })
  },
  clickOrgItem({ id, name }: { id: string; name: string }) {
    return track('Orgs: Click Org Item', { id, name })
  },
  clickFiler({ filter }: { filter: string }) {
    return track('Orgs: Click Filter', { filter })
  },
  clickOverviewLink() {
    return track('Orgs: Click Overview Link')
  }
}))
